import React from 'react';
import { Link } from 'react-router-dom';
import PDF from '../helpers/PDF';

function PersonalArticle(props) {
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-2">
          <figure className="image is-4by5">
            <img className='has-ratio p-1' src={props.data.photo} alt='' />
          </figure>
        </div>
        <div className="column is-10 is-flex is-flex-direction-column is-justify-content-space-between">
          <p className='title is-size-4-mobile is-3 has-text-centered'>{props.data.topic}</p>
          <p className='title is-5 has-text-centered has-text-success'>Like Count = {props.data.likes?.length}</p>
          <div className="columns is-flex is-justify-content-center">
            <button className="button m-2 btn" style={{ width: '100px' }} onClick={() => { props.handlePopup(props.data) }} >
              <span className="icon is-small">
                <i className="fab fa-readme"></i>
              </span>
              <span>Read</span>
            </button>
            <Link to={`/articles/edit/${props.data._id}`} className="button m-2 btn" style={{ width: '100px' }}>
              <span className="icon is-small">
                <i className="fas fa-edit"></i>
              </span>
              <span>Edit</span>
            </Link>
            <button className="button m-2 btn" style={{ width: '100px' }} onClick={() => { PDF(props.data) }}>
              <span className="icon is-small">
                <i className="fas fa-print"></i>
              </span>
              <span>Print</span>
            </button>
            <button className="button m-2 del-btn" style={{ width: '100px' }} onClick={() => { props.handleDeleteArticle(props.data?._id) }}>
              <span className="icon is-small">
                <i className="fas fa-trash-alt"></i>
              </span>
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PersonalArticle;